import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import classes from '../style.module.scss';

const ImageModal = memo(({
  image, onClose, zIndex = 1003,
}) => {
  const timeout = useRef(null);

  const onMouseMove = (e) => {
    clearTimeout(timeout.current);

    if (e.target.closest('#modal_content')) {
      return;
    }

    timeout.current = setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <Modal
      className={classes.image_modal_wrapper}
      open={!!image}
      onMouseMove={onMouseMove}
      zIndex={zIndex}
    >
      <img src={image} alt="image" />
    </Modal>
  );
});

ImageModal.propTypes = {
  image: PropTypes.string,
  onClose: PropTypes.func,
  zIndex: PropTypes.number,
};

export default ImageModal;
